<template>
  <div data-testid="stores-list" class="flex flex-col gap-8 py-9">
    <Headline look="h1" weight="normal" tag="h2">
      {{ $t('store_finder.list.title') }}
    </Headline>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      <div
        v-for="(abbr, i) in sortedCitiesAbbr"
        :key="`abbr-${i}`"
        class="mb-4 flex flex-col gap-4"
      >
        <Headline
          look="h2"
          tag="h3"
          is-uppercase
          :loading="loading"
          :data-testid="`country-${abbr}`"
        >
          {{ abbr }}
        </Headline>
        <div>
          <div
            v-for="(store, j) in sortedStores[abbr]"
            :key="`store-${j}`"
            class="mb-1"
          >
            <FimLink
              :to="storeLink(store)"
              text-size="md"
              class="pr-1 underline"
            >
              {{ getStoreName(store) }}
            </FimLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IStore } from '~/rpcMethods/stores'

const props = defineProps({
  loading: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  stores: {
    type: Array as PropType<IStore[]>,
    required: true,
  },
})

const sortedStores = computed(() => {
  const filteredStores = addCityPageStore(props.stores)
  return filteredStores.reduce<{
    [key: string]: IStore[]
  }>((result, store) => {
    const cityLetter = store.city.charAt(0).toLowerCase()
    const cityStores = result?.[cityLetter] ?? []
    return {
      ...result,
      [cityLetter]: [...cityStores, store].sort((a, b) => {
        return getStoreName(a).localeCompare(getStoreName(b))
      }),
    }
  }, {})
})

const sortedCitiesAbbr = computed(() => {
  return props.stores.reduce<string[]>((result, partner) => {
    const cityLetter = partner.city.charAt(0).toLowerCase()
    const value = [...result, cityLetter]
    return [...new Set(value)].sort((a, b) => a.localeCompare(b))
  }, [])
})

const $fimLocalePath = useFimLocalePath()
const storeLink = (store: IStore) => {
  return getStoreUrl(store, $fimLocalePath, true)
}
</script>
